<template>
  <VueFragment>
    <a v-if="isLink" href="/" class="header-logo">
      <span class="logo disable-text-select">&#62;&nbsp;CHOIBOI&#95;</span>
    </a>

    <span v-if="!isLink" class="logo" :style="nonLinkChoiboiStyle">&#62;&nbsp;CHOIBOI&#95;</span>
  </VueFragment>
</template>

<script>
import { Fragment as VueFragment } from 'vue-fragment';

export default {
  name: 'ChoiboiLogo',
  components: {
    VueFragment
  },
  props: {
    isLink: {
      type: Boolean,
      default: true
    },
    fontSize: {
      type: String,
      default: "20px"
    }
  },
  computed: {
    nonLinkChoiboiStyle() {
      return {
        "font-size": this.fontSize
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.logo {
  color: $primaryGreen;
  font-weight: bold;
  font-size: 20px;
  padding: 5px 0;
}
</style>
